import { createSlice } from "@reduxjs/toolkit";
import { initialCertificateOfInsuranceState } from "./certificateOfInsurance.types";
import { fetchCertificateOfInsuranceList } from "./certificateOfInsuranceActions";
import { LoadState } from "../../constants/enums";

const certificateOfInsuranceSlice = createSlice({
  name: "certificateOfInsurance",
  initialState: initialCertificateOfInsuranceState,
  reducers: {
    clearCertificateOfInsuranceState: (state) => {
      return initialCertificateOfInsuranceState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCertificateOfInsuranceList.pending, (state) => {
      state.loading = LoadState.InProgress;
      state.certificateOfInsuranceList = [];
    });
    builder.addCase(
      fetchCertificateOfInsuranceList.fulfilled,
      (state, action) => {
        state.loading = LoadState.Loaded;
        state.certificateOfInsuranceList = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      },
    );
    builder.addCase(fetchCertificateOfInsuranceList.rejected, (state) => {
      state.loading = LoadState.Failed;
    });
  },
});

export const { clearCertificateOfInsuranceState } =
  certificateOfInsuranceSlice.actions;

export const certificateOfInsuranceReducer =
  certificateOfInsuranceSlice.reducer;
